import type React from "react";
import {
  DocSolidIcon,
  DocumentSolidIcon,
  GifSolidIcon,
  ImgSolidIcon,
  JpegSolidIcon,
  JsonSolidIcon,
  JpgSolidIcon,
  Pdf2SolidIcon,
  PngSolidIcon,
  SvgSolidIcon,
  WebpSolidIcon,
  XlsSolidIcon,
  XlsxSolidIcon,
  ZipSolidIcon,
} from "@sumprio/ui/icons";
import { getFileExtension } from "utils/files";

export type FileIconSize = "xxs" | "xs" | "sm" | "default" | "lg" | "xl";

export type FileIconComponent = React.ComponentType<{ size?: FileIconSize }>;

const FILE_EXTENSION_ICONS: Record<string, FileIconComponent> = {
  PNG: PngSolidIcon,
  JPG: JpgSolidIcon,
  JPEG: JpegSolidIcon,
  GIF: GifSolidIcon,
  WEBP: WebpSolidIcon,
  SVG: SvgSolidIcon,
  BMP: ImgSolidIcon,
  PDF: Pdf2SolidIcon,
  XLS: XlsSolidIcon,
  XLSX: XlsxSolidIcon,
  CSV: XlsSolidIcon,
  DOC: DocSolidIcon,
  DOCX: DocSolidIcon,
  ZIP: ZipSolidIcon,
  JSON: JsonSolidIcon,
};

export function getFileTypeIcon(fileName: string): FileIconComponent {
  return FILE_EXTENSION_ICONS[getFileExtension(fileName)] ?? DocumentSolidIcon;
}
